import { defineNuxtPlugin, useHead, useRuntimeConfig } from '#app'
import { useCountryConfig } from '~/composables/useCountryConfig'

export default defineNuxtPlugin(() => {
  const { hubspotBusinessUnitId } = useCountryConfig()
  const { hubspotChatEnabled } = useRuntimeConfig().public

  if (!hubspotChatEnabled || !hubspotBusinessUnitId)
    return

  useHead({
    script: [
      {
        id: 'hs-script-loader',
        src: `https://js-eu1.hs-scripts.com/26993885.js?businessUnitId=${hubspotBusinessUnitId}`,
        async: true,
        defer: true,
        tagPosition: 'bodyClose',
      },
    ],
  })
})
